import { MenuItem, MenuItemProps } from '@mui/material'

const DropdownItem = ({ children, ...otherProps }: MenuItemProps) => {
  return (
    <MenuItem {...otherProps}>{children}</MenuItem>
  )
}

export default DropdownItem
